module.exports = __webpack_public_path__ + "media/step2@2x_076996.png";